module.exports = __webpack_public_path__ + "static/Referral-v2-8275b270a1f3d9cd74a9ad9df8dcf29a.pdf";